import React from "react";
import styles from "./styles/PhoneNumberButton.scss";
import { Button } from "../../../components/Button/Button";
import { HoneypotInput, useAntiBotMeasures } from "../../../hooks/useAntiBotMeasures";

interface CallButtonProps {
  handleCall: () => void;
  isShownButton: boolean;
  phoneNumber?: string | null;
  isLoading?: boolean;
}

export const CallButton = (props: CallButtonProps) => {
  const { handleCall, isShownButton, phoneNumber, isLoading } = props;
  const { honeypotRef, handleClickWithAntiBotMeasure } = useAntiBotMeasures();

  const handleClick = (event: React.MouseEvent) =>
    handleClickWithAntiBotMeasure(event, handleCall);

  return (
    <React.Fragment>
      <HoneypotInput ref={honeypotRef} />
      <Button
        onClick={handleClick}
        type="primary"
        className={`${styles.button} ${styles.phoneNumber}`}
        loading={isLoading}
      >
        {isShownButton && phoneNumber ? phoneNumber : "Nazovite"}
      </Button>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/CallButton.tsx